import { mixHex } from './color-utils';

export function harvestCssVars(cssVars: string) {
	const regex = /\{(.+?)\}/;

	return regex.exec(cssVars.replace(/https:/g, 'https__COLON__'))[1] // 1 corresponds to the first match group
		.split(';')
		.slice(0, -1)
		.map(declaration => declaration.split(':').map(part => part.trim()))
		.reduce((map, [property, value]) => {
			map[property] = value.replace('https__COLON__', 'https:');
			return map;
		}, {});
}

let cachedStyles: CSSStyleDeclaration | null = null;
export function getCssVarValue (varName: string) {
	const rootStyles = cachedStyles ?? getComputedStyle(document.documentElement);
	cachedStyles = rootStyles;
	const value = rootStyles.getPropertyValue(varName).trim();

	const colorMix = value.replace(/\s+/g, '').match(/color-mix\(insrgb,(#[0-9a-fA-F]{6})(\d+)%?,(#[0-9a-fA-F]{6})\)/);
	// (ignoring whitespace) if color looks like -> color-mix(in srgb,#hex1 p%,#hex2), we have to parse and mix it
	// done for org appearance
	if (!colorMix)
		return value;
	else {
		const [
			_, color1, // first hex color
			p, // percentage
			color2 // second hex color
		] = colorMix;

		return mixHex(color1, color2, parseInt(p) / 100);
	}
}

export function invalidateCache () {
	cachedStyles = null;
}